import { type MCPServerInfo } from '../../types';

const PubmedServer: MCPServerInfo = {
  serverId: 'PUBMED',
  name: 'PubMed',
  slug: 'pubmed',
  description:
    'A MCP server that allows to search and fetch articles from PubMed. PubMed is a database of over 35 million citations for biomedical literature from MEDLINE, life science journals, and online books.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/grll/pubmedmcp',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default PubmedServer;
